export default __webpack_public_path__ + "static/media/comics_opt_bw.872a8636.jpg";